import React, { useState, useEffect, useCallback, useMemo } from "react";
import Cookies from "universal-cookie";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const agruparModulosPlano = (listaPlana) => {
  const mapa = new Map();

  (listaPlana || []).forEach((item) => {
    if (!mapa.has(item.id_modulo)) {
      mapa.set(item.id_modulo, {
        id_modulo: item.id_modulo,
        nombre: item.modulo_nombre,
        icono: item.modulo_icono,
        ruta: item.modulo_ruta,
        orden: item.modulo_orden,
        submodulos: [],
      });
    }

    if (item.id_submodulo !== null) {
      const padre = mapa.get(item.id_modulo);
      if (padre && !padre.submodulos.some((s) => s.id_submodulo === item.id_submodulo)) {
        padre.submodulos.push({
          id_modulo: item.id_modulo,
          id_submodulo: item.id_submodulo,
          nombre: item.submodulo_nombre,
          icono: item.submodulo_icono,
          ruta: item.submodulo_ruta,
          orden: item.submodulo_orden,
        });
      }
    }
  });

  const arbol = Array.from(mapa.values());
  arbol.sort((a, b) => (a.orden ?? 99) - (b.orden ?? 99));
  arbol.forEach((mod) => {
    mod.submodulos.sort((a, b) => (a.orden ?? 99) - (b.orden ?? 99));
  });
  return arbol;
};

function Aside() {
  const navigate = useNavigate();
  const cookies = useMemo(() => new Cookies(), []);
  const location = useLocation();
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  const [nombre, setNombre] = useState("");
  const [perfil, setPerfil] = useState("");
  const [openMenu, setOpenMenu] = useState(null);
  const [modulosMenu, setModulosMenu] = useState([]);
  const [cargandoMenu, setCargandoMenu] = useState(true);

  const fetchMenu = useCallback(async () => {
    const perfilId = cookies.get("perfilId");
    if (!perfilId) {
      setModulosMenu([]);
      setCargandoMenu(false);
      return;
    }

    try {
      const [resModulos, resPermisos] = await Promise.all([
        axios.get(`${baseURL}/api/Modulos`),
        axios.get(`${baseURL}/api/Perfiles/${perfilId}/Permisos`),
      ]);

      const mods = Array.isArray(resModulos.data)
        ? resModulos.data
        : resModulos.data?.data || [];

      const perms = Array.isArray(resPermisos.data)
        ? resPermisos.data
        : resPermisos.data?.data || [];

      const arbol = agruparModulosPlano(mods);

      const tieneAcceso = (idModulo, idSubmodulo) =>
        perms.some(
          (p) =>
            String(p.id_modulo) === String(idModulo) &&
            String(p.id_submodulo || 0) === String(idSubmodulo || 0) &&
            p.puede_ver === true
        );

      const filtrado = arbol
        .map((mod) => {
          const subsVisibles = mod.submodulos.filter((sub) =>
            tieneAcceso(sub.id_modulo, sub.id_submodulo)
          );
          return { ...mod, submodulos: subsVisibles };
        })
        .filter((mod) => tieneAcceso(mod.id_modulo, null) || mod.submodulos.length > 0);

      setModulosMenu(filtrado);

      // Validar que la ruta actual sea accesible
      const rutasPermitidas = [];
      filtrado.forEach((mod) => {
        if (mod.ruta) rutasPermitidas.push(mod.ruta);
        mod.submodulos.forEach((sub) => {
          if (sub.ruta) rutasPermitidas.push(sub.ruta);
        });
      });
      rutasPermitidas.push("/inicio");

      const pathActual = location.pathname;
      const rutaPermitida = rutasPermitidas.some(
        (r) => pathActual === r || pathActual.startsWith(r + "/")
      );
      if (!rutaPermitida && pathActual !== "/") {
        navigate("/inicio");
      }
    } catch (err) {
      console.error("Error al cargar menú:", err);
      setModulosMenu([]);
    } finally {
      setCargandoMenu(false);
    }
  }, [baseURL, cookies, location.pathname]);

  useEffect(() => {
    if (!cookies.get("idUsuario")) {
      navigate("/");
    } else {
      setNombre(cookies.get("nombresApellidos") || "");
      setPerfil(cookies.get("perfil") || "");
      fetchMenu();
    }
  }, [location, fetchMenu]);

  const cerrarSesion = () => {
    cookies.remove("idUsuario", { path: "/" });
    cookies.remove("nombreUsuario", { path: "/" });
    cookies.remove("nombresApellidos", { path: "/" });
    cookies.remove("correo", { path: "/" });
    cookies.remove("perfilId", { path: "/" });
    cookies.remove("perfil", { path: "/" });
    cookies.remove("token", { path: "/" });
    navigate("/");
  };

  const toggleMenu = (menuName) => {
    setOpenMenu(openMenu === menuName ? null : menuName);
  };

  const formatName = (name) => {
    if (!name) return "";
    return name
      .toLowerCase()
      .split(" ")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  };

  const iconoClase = (icono) => {
    if (!icono) return "fas fa-circle";
    return icono.startsWith("fa-") ? `fas ${icono}` : `fas fa-${icono}`;
  };

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      <NavLink to="/inicio" className="brand-link">
        <img
          src="../dist/img/ImgGMF.png"
          alt="Logo"
          className="brand-image"
        />
        <span className="brand-text font-weight-light">CRM - PWS</span>
      </NavLink>

      <div className="sidebar">
        <div className="user-panel mt-3 pb-3 mb-3 d-flex align-items-center">
          <div className="image">
            <img
              src="dist/img/usuario.png"
              className="img-circle elevation-2"
              alt="User"
            />
          </div>
          <div className="info">
            <span className="d-block text-white">{formatName(nombre)}</span>
            <span style={{ fontSize: "0.75rem", color: "rgba(255,255,255,0.55)" }}>
              {perfil}
            </span>
          </div>
        </div>

        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column" role="menu">
            {cargandoMenu ? (
              <li className="nav-item text-center py-3">
                <span style={{ color: "rgba(255,255,255,0.5)", fontSize: "0.85rem" }}>
                  <i className="fas fa-spinner fa-spin mr-2" />
                  Cargando menú...
                </span>
              </li>
            ) : (
              modulosMenu.map((mod) =>
                mod.submodulos.length > 0 ? (
                  <li
                    key={`mod_${mod.id_modulo}`}
                    className={`nav-item has-treeview ${openMenu === `mod_${mod.id_modulo}` ? "menu-open" : ""}`}
                  >
                    <a
                      href="#!"
                      className="nav-link"
                      onClick={() => toggleMenu(`mod_${mod.id_modulo}`)}
                    >
                      <i className={`nav-icon ${iconoClase(mod.icono)}`} />
                      <p>
                        {mod.nombre}
                        <i className="right fas fa-angle-left" />
                      </p>
                    </a>
                    <ul className="nav nav-treeview">
                      {mod.submodulos.map((sub) => (
                        <li key={`sub_${sub.id_modulo}_${sub.id_submodulo}`} className="nav-item">
                          <NavLink to={sub.ruta} className="nav-link">
                            <i className={`${iconoClase(sub.icono)} nav-icon`} />
                            <p>{sub.nombre}</p>
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </li>
                ) : (
                  <li key={`mod_${mod.id_modulo}`} className="nav-item">
                    <NavLink to={mod.ruta} className="nav-link">
                      <i className={`nav-icon ${iconoClase(mod.icono)}`} />
                      <p>{mod.nombre}</p>
                    </NavLink>
                  </li>
                )
              )
            )}

            <li className="nav-item" style={{ marginTop: "auto", paddingTop: "1rem" }}>
              <a href="#!" className="nav-link" onClick={cerrarSesion}>
                <i className="nav-icon fas fa-sign-out-alt" />
                <p>Cerrar sesión</p>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  );
}

export default Aside;
